import type { FaireProductEntity } from "../../entity_types/product";

export const p_fgdrevph79: FaireProductEntity = {
  token: "p_fgdrevph79",
  type: "product",
  name: "Todos Santos Candle",
  brandToken: "b_c3hepkjc1t",
  brandName: "Nopalera",
  imageUrl:
    "https://cdn.faire.com/fastly/eb33a3aa2b11a16866287488726a6883e40ea9e1ff74b0c36b0d6c29cdc837cf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ddbab35188c5e9e1d2ad91e30523f2ff455221cc94470f5f42c23176a92a4c3e.jpeg",
    "https://cdn.faire.com/fastly/08f5ace6acc4fa1376c2d994c04e19de7800d124cacaca1651f86e370fe27e14.jpeg",
    "https://cdn.faire.com/fastly/aebab26837bae6480ab86f39d77fe410e27dc564a4f2f2889b252f6a8bb7cac1.jpeg",
  ],
  priceDollars: 25,
  description:
    "8.5 oz | 241 g\nBurn time: 60 hours\n\nTodos Santos - Where azure waters meet golden sands. The hidden coastal town Todos Santos provides a respite for the urban weary. Enchanting notes of eucalyptus, vanilla and palo santo  carry you on an evocative voyage into the recesses of your imagination.\n\nTOP: Basilic, Mint, Eucalyptus\nMID: Violet Flower, Guatemalan Cardamom, Vanilla\nBASE: Palo Santo, Sandalwood, Patchouli\n\nBENEFITS\n • Non-toxic Luxury Fragrance\n • Phthalates Free | Paraffin Free | Palm Oil Free | Vegan\n • Coco-Soy Wax Blend\n • Organic Cotton Wick\n\nOur glass vessels were hand blown by artisans in Mexico City. Be sure to use them for your favorite Margarita or Paloma once you’ve burned through your candle.\n",
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:46.247Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
